export const OBTENER_OPERACIONES = 'operaciones_traer_todas';
export const ERROR = 'operaciones_error';
export const LOADING = 'operaciones_loading';